<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>代采单商品列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.woid"
                    placeholder="代采单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.planid"
                    placeholder="代采计划编号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_no"
                    placeholder="货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.city"
                    multiple
                    placeholder="选择城市"
                  >
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.market_name"
                    placeholder="市场"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.pgid"
                    filterable
                    multiple
                    placeholder="选择代采组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionsPg"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.status" placeholder="选择代采单状态">
                    <el-option
                      v-for="item in resData.optionsStatus"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.order_owner"
                    filterable
                    placeholder="订单负责人"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.owner_option"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.ptype"
                    placeholder="代采计划生成方式"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未代采" value="0"></el-option>
                    <el-option
                      v-for="item in resData.ptype_option"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.order_type"
                    placeholder="代采开单方式"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="实数单" value="1"></el-option>
                    <el-option label="排单单" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.is_dispense" placeholder="小店分发">
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="提交时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="支付时间：">
                  <el-date-picker
                    v-model="form.pay_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-checkbox
            v-model="form.bad_flag"
            style="margin-left: 80%"
            true-label="1"
            >在途坏账</el-checkbox
          >
          <el-button
            style="margin-left: 20px"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column align="center" prop="woid" label="代采订单编号">
              <template slot-scope="scope">
                <el-button type="text" @click="handleClick(scope.row)">
                  {{ scope.row.woid }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="planid" label="代采计划编号">
              <template slot-scope="scope">
                <el-button type="text" @click="handleClickPlan(scope.row)">
                  {{ scope.row.planid }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column align="center" label="代采计划生成方式">
              <template slot-scope="scope">
                <p>{{ scope.row.wcg_plan_ptype }}</p>
                <p style="color: #2d59ec; font-size: 14px; line-height: 0">
                  {{ scope.row.is_dispense_label }}
                </p>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="goods_name" label="商品名称">
            </el-table-column>
            <el-table-column align="center" prop="goods_kh" label="商品款号">
            </el-table-column>
            <el-table-column align="center" prop="goods_no" label="商品货号">
            </el-table-column>
            <el-table-column align="center" prop="co_val" label="颜色">
            </el-table-column>
            <el-table-column align="center" prop="si_val" label="尺码">
            </el-table-column>
            <el-table-column align="center" prop="plan_num" label="计划">
            </el-table-column>
            <el-table-column align="center" prop="dk_num" label="前置">
            </el-table-column>
            <el-table-column align="center" prop="num" label="数量">
            </el-table-column>
            <el-table-column align="center" prop="price" label="代采价">
            </el-table-column>
            <el-table-column align="center" prop="total" label="开单价小计">
            </el-table-column>
            <el-table-column
              align="center"
              prop="activity_fee"
              label="活动服务费小计"
            >
            </el-table-column>
            <el-table-column align="center" prop="" label="佣金">
              <template slot-scope="scope">
                {{ scope.row.service_fee }}({{ scope.row.service_fee_rate }})
              </template>
            </el-table-column>
            <el-table-column
              prop="dispense_commission_amount"
              label="小店佣金"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column align="center" prop="" label="退货服务费">
              <template slot-scope="scope">
                {{ scope.row.refund_service_fee }}({{
                  scope.row.refund_service_fee_rate
                }})
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="true_total"
              label="实付金额小计"
            >
            </el-table-column>
            <el-table-column align="center" prop="market_nikename" label="市场">
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="status_label"
              label="代采单状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="owner_admin_name"
              label="订单负责人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="提交时间"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pay_time"
              label="支付时间"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wcg_order_type"
              label="代采开单方式"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_return_day"
              label="承诺回货时间"
              width="100"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst.js";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "PurchaseOrderGoodsList",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.resData) {
        vm.fetchData(true);
      }
    });
  },
  data() {
    return {
      resData: null,
      form: {
        status: "",
        bad_flag: false,
        create_time: this.defaultDate(),
        order_owner: "",
        ptype: "",
        is_dispense: "",
        city: [],
      },
      citys: CITY,
      loading: false,
      tableLoading: false,
      url: "/erp/WcgOrder/getGoodsList",
      status: -1,
      curPage: 1,
      filterFold: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.form.is_excel = 0;
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 3);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      if (row.cg_type == 2) {
        this.$message.error("计划外已垫付代采订单不支持跳转");
        return;
      }
      this.$router.push(`/home/purchasing/purchaseorderlist?woid=${row.woid}`);
    },
    handleClickPlan(row) {
      let url = "/home/purchasing/purchaseplanlist?planid=";
      if (row.is_pre_storage == 1) {
        // 跳到前置仓计划页面
        url = "/home/preStockPlanEdit/";
      }

      this.$router.push(`${url}${row.planid}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    selectStatus(key) {
      this.loading = true;
      this.form.status = this.status = key;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseOrderGoodsList.vue